export const actionTypes = {
  CLEAR_PARAMS: "CLEAR_PARAMS",
  UPDATE_PARAMS: "UPDATE_PARAMS",
  CLEAR_LOCATIONS: "CLEAR_LOCATIONS",
  UPDATE_LOCATIONS: "UPDATE_LOCATIONS",
  UPDATE_RESPONSE: "UPDATE_RESPONSE",
  UPDATE_DISPLAY_MODE: "UPDATE_DISPLAY_MODE",
} as const;
